<template>
    <nav class="navbar bg-dark flex-nowrap d-flex flex-row justify-content-between">
        <!-- LOGO AND TITLE TEXT -->
        <div class="d-flex flex-column mr-3">
            <div class="d-flex flex-row align-items-center">
                <div>
                    <div class="d-flex flex-column">
                        <router-link
                            :to="{ name: user.permissions.superadmin ? 'home_superadmin' : 'home' }"
                            class="nav-link nopadding mr-3"
                        >
                            <img class="top-logo" src="@/assets/images/drugsafe-shield-icon-no-text.png" alt="" />
                        </router-link>
                    </div>
                </div>
                <!-- TITLE TEXT (HIDDEN IF WINDOW WIDTH IS BELOW 650 PX) -->
                <div class="hide650px">
                    <div class="d-flex flex-column navbar-brand" style="font-size: 100%">
                        DRUGSAFE® WEBTOOL
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex flex-column justify-content-between">
            <div class="d-flex flex-row justify-content-end align-items-center">
                <!-- HAMBURGER MENU -->
                <div class="d-flex flex-column d-block d-md-none">
                    <div class="btn-group align-items-center mr-4">
                        <img
                            class="dropdown-toggle invert"
                            id="dropdownMenu"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            src="@/assets/images/hamburger_icon.svg"
                            alt=""
                        />
                        <div class="dropdown-menu account-droplist nopadding" aria-labelledby="dropdownMenu">
                            <Sidebar />
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column">
                    <div class="btn-group align-items-center mr-4">
                        <!-- LOGGED IN USER NAME (HIDDEN IF WINDOW WIDTH IS BELOW 650 PX) -->
                        <label
                            for="dropdownAccount"
                            data-toggle="dropdown"
                            class="text-white mr-3 hide650px"
                            :style="{ marginBottom: '0px' }"
                        >
                            <i>{{ `${user.first_name}\xa0${user.last_name}` }}</i>
                        </label>
                        <!-- LOGGED IN USER AVATAR -->
                        <img
                            class="avatar dropdown-toggle"
                            id="dropdownAccount"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            src="@/assets/images/avatar.png"
                            alt=""
                            :style="{ marginRight: '5px' }"
                        />
                        <!-- AVATAR DROPDOWN MENU -->
                        <div class="dropdown-menu account-droplist" aria-labelledby="dropdownAccount">
                            <router-link :to="{ name: 'user.my_account' }" class="nav-link">{{
                                $t('update_account')
                            }}</router-link>
                            <a class="nav-link" v-on:click.prevent="logout" style="cursor: pointer">
                                {{ $t('logout') }}
                            </a>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column"><LocaleSwitcher /></div>
            </div>
        </div>
    </nav>
    <!-- UNUSED -->
    <!-- <div class="w-100">
        <input
            class="form-control form-control-dark w-40"
            type="text"
            :placeholder="$t('search')"
            aria-label="Search"
            autocomplete="off"
            v-model="searchItem"
            v-on:input="search"
            disabled
        />
        <ul
            id="searchBar"
            style="position:absolute;
                background-color: #fff;
                line-height: 30px;
                font-size: 16px;
                list-style: none;"
        >
            <li v-for="(index, item) in searchItems" v-bind:key="index">
                <span v-if="item.type === 'user'">
                    <router-link :to="{ name: 'user.index' }">
                        {{ $t('users') }} #{{ item.id }} {{ item.first_name }} {{ item.last_name }} {{ item.email }}
                    </router-link>
                </span>
                <span v-if="item.type === 'portal'">
                    <span v-if="user.role === 'superadmin'">
                        <router-link :to="{ name: 'pharmacy.index' }">
                            {{ $t('pharmacies') }} #{{ item.id }} {{ item.name }} {{ item.country }} {{ item.city }}
                        </router-link>
                    </span>
                    <span v-else>
                        <router-link :to="{ name: 'my_pharmacy' }">
                            {{ $t('pharmacy') }} #{{ item.id }} {{ item.name }} {{ item.country }} {{ item.city }}
                        </router-link>
                    </span>
                </span>
            </li>
        </ul>
    </div>
    <img
        v-if="notifications === 0"
        class="envelope-notifications ml-5 h-40"
        src="@/assets/images/envelope.png"
        alt=""
    /> -->
</template>

<script>
import { mapState, mapActions } from 'vuex';
import LocaleSwitcher from './LocaleSwitcher';
import Sidebar from '@/components/Sidebar';
import { handleAxiosError, search } from '@/services/axiosService';

export default {
    components: { LocaleSwitcher, Sidebar },
    data() {
        return {
            searchItem: '',
            searchItems: [],
            error: {},
            id: localStorage.getItem('id'),
            incomingRequests: [],
            outcomingRequests: []
        };
    },
    created() {
        //this.connectSocket(this.user.id);
    },
    computed: {
        ...mapState('account', ['status', 'user']),
        ...mapState('notification', ['notifications'])
    },
    methods: {
        ...mapActions('account', ['logout']),
        connectSocket(id) {
            if (process.env.VUE_APP_ENABLE_SOCKET === 'true') {
                this.sockets.subscribe('emitNotification' + id, message => {
                    let data = JSON.parse(message.message);
                    if (data.data.data.mode === '') {
                        // this.newNotifications += 1;
                    }
                });
            }
        },
        // search (NOT USED)
        async search() {
            try {
                let data = { searchItem: this.searchItem };
                this.searchItems = await search(data);
            } catch (error) {
                handleAxiosError(error);
            }
        }
    }
};
</script>
